<div class="review-voicemail">
    <audio [hidden]="!audioObject?.fileName" #audioPlayer controls></audio>
    <label *ngIf="false && audioObject?.fileName" class="label" title="File: {{audioObject?.fileName}}">{{shortenString(audioObject?.fileName)}}</label>
    <label *ngIf="!audioObject?.fileName" class="label">Loading audio file...</label>
</div>